export default __webpack_public_path__ + "static/media/smile.89f57b17.svg";